import { takeLatest, select } from 'redux-saga/effects';

import { CHANGE_SORTING } from './constants';
import { getSortField, getSortOrder } from './selectors';
import { uri, updateURL } from '../../../utils';

const SORTING_PARAM = 'sort_by';

function* changeURL(action) {
  try {
    const { field, order } = action.payload;

    uri.removeSearch(SORTING_PARAM);
    uri.addSearch(SORTING_PARAM, order ? `${field},${order}` : field);
    yield updateURL();
  } catch (error) {
    console.error('Произошла ошибка', error);
  }
}

export function* getSortParams() {
  const field = yield select(getSortField);
  const order = yield select(getSortOrder);
  return { [SORTING_PARAM]: order ? `${field},${order}` : field };
}

export default function* () {
  yield takeLatest(CHANGE_SORTING, changeURL);
}
